var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "step_component_wrapper"
    }
  }, [_c('div', {
    staticClass: "slot-content",
    staticStyle: {
      "text-align": "center"
    }
  }, [(_vm.reference == 'date') ? _c('div', [_c('datepicker', {
    staticClass: "col-xs-6 col-xs-offset-3",
    staticStyle: {
      "padding": "0px",
      "color": "black"
    },
    attrs: {
      "full-month-name": true,
      "clear-button": true,
      "placeholder": _vm.$Jed.firstUpperTranslate('pick a date as validity', null),
      "format": "dd / MM / yyyy",
      "language": _vm.datePickLang
    },
    model: {
      value: (_vm.date),
      callback: function($$v) {
        _vm.date = $$v
      },
      expression: "date"
    }
  })], 1) : _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon",
    class: {
      'error_highlight': !_vm.machineValid
    }
  }, [_c('i', {
    class: _vm.$root.icons.search_btn,
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.matricola),
      expression: "matricola"
    }],
    staticClass: "form-control",
    class: {
      'error_highlight': !_vm.machineValid
    },
    attrs: {
      "id": "selector",
      "type": "text",
      "placeholder": _vm.machinePlaceholder[_vm.machineValid ? 0 : _vm.machineErrorIndex]
    },
    domProps: {
      "value": (_vm.matricola)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.matricola = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "slot-button"
  }, [(!_vm.backTo1Allowed) ? _c('button', {
    staticClass: "btn btn-danger",
    on: {
      "click": function($event) {
        _vm.$root.logout()
      }
    }
  }, [_vm._v("Logout")]) : _c('button', {
    staticClass: "btn btn-danger",
    on: {
      "click": function($event) {
        _vm.$emit('backward')
      }
    }
  }, [_vm._v(_vm._s(_vm.$Jed.firstUpperTranslate('back', null)))]), _vm._v(" "), (!_vm.$Behaviors.requestUpdateReference) ? _c('popover-alert', {
    attrs: {
      "effect": "fade",
      "placement": "top",
      "title": _vm.$Jed.firstUpperTranslate('are you sure?', null),
      "content": _vm.$Jed.firstUpperTranslate('do you want to proceed without applying any validity filter?', null),
      "ok": _vm.load,
      "ok_text": _vm.$Jed.firstUpperTranslate('yes', null),
      "no_text": _vm.$Jed.firstUpperTranslate('no', null),
      "popoverStyle": {
        right: '10px',
        'max-width': '200px',
        width: '100%',
        'font-size': 'small',
        height: 'max-content',
        bottom: '60px'
      },
      "arrowStyle": {
        left: '75%'
      },
      "textStyle": {
        color: '#222'
      },
      "classes": "autoleft autotop"
    }
  }, [_c('button', {
    staticClass: "btn btn-default",
    staticStyle: {
      "width": "auto"
    }
  }, [_vm._v(_vm._s(_vm.$Jed.firstUpperTranslate('skip', null)))])]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "disabled": _vm.empty || _vm.forwarding
    },
    on: {
      "click": _vm.forward
    }
  }, [_vm._v(_vm._s(_vm.$Jed.firstUpperTranslate('load', null)))])], 1)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-11d5d328","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/loader/steps/ImpostazioneCompatibilità.vue
// module id = 1509
// module chunks = 1